import React from 'react';
import './Error.scss';
import { Icon } from '../../../../components/common/IconLibrary';

interface ErrorProps {
  onBack: () => void;
}

const Error: React.FC<ErrorProps> = ({ onBack }) => {
  return (
    <div className="lp-result">
      <div className="lp-result__icon lp-result__icon--error">
        <Icon iconName="cancel" iconColor="orange" size={36} />
      </div>
      <h3 className="lp-result__title">Ups, inténtalo más tarde</h3>
      <p className="lp-result__message">
        No hemos podido procesar tu solicitud. Por favor inténtalo de nuevo más tarde.
      </p>
      <button className="lp-result__action" onClick={onBack}>
        Volver al inicio de sesión
      </button>
    </div>
  );
};

export default Error;
